import { implementCustomExpressions } from '../__generated/implementation.js';
import { FenixVariant } from '../__generated/model/index.js';
import { AVAILABLE_LEG_TYPES_RECTANGLE } from './top-rectangle.js';
export const topDanishOvalExpressions = implementCustomExpressions({
    TopDanishOval: {
        $objectName: (self)=>self.fenixVariant === FenixVariant.Birch ? 'FENIX_OVAAL_OVAL' : 'OVAAL_OVAL',
        $availableLegTypes: ()=>AVAILABLE_LEG_TYPES_RECTANGLE
    }
});

//# sourceMappingURL=top-danish-oval.js.map